import { render, staticRenderFns } from "./schUseProDetails.vue?vue&type=template&id=1a7f5b08&scoped=true"
import script from "./schUseProDetails.vue?vue&type=script&lang=js"
export * from "./schUseProDetails.vue?vue&type=script&lang=js"
import style0 from "./schUseProDetails.vue?vue&type=style&index=0&id=1a7f5b08&prod&lang=scss&scoped=true"
import style1 from "./schUseProDetails.vue?vue&type=style&index=1&id=1a7f5b08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7f5b08",
  null
  
)

export default component.exports